var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26796_253088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9355 12H29.0645C30.9492 12 32.6641 12.7734 33.9082 14.0156C35.1543 15.2598 35.9277 16.9766 35.9277 18.8633V29.1387C35.9277 31.0215 35.1543 32.7363 33.9121 33.9805L33.9082 33.9844C32.6621 35.2285 30.9473 36 29.0664 36H18.9355C17.0488 36 15.332 35.2266 14.0879 33.9844L14.041 33.9316C12.8262 32.6934 12.0723 30.998 12.0723 29.1367V18.8633C12.0723 16.9746 12.8437 15.2598 14.0879 14.0156C15.332 12.7715 17.0469 12 18.9355 12ZM29.9453 18.0586L29.959 18.0801H34.1777C34.0078 16.9707 33.4785 15.9746 32.7168 15.2109C31.7793 14.2734 30.4863 13.6914 29.0645 13.6914H27.332L29.9453 18.0586ZM27.9941 18.0801L25.3672 13.6914H19.6055L22.2637 18.0801H27.9941ZM20.2969 18.0801L17.7266 13.834C16.7871 14.0605 15.9453 14.5469 15.2832 15.2109C14.5215 15.9727 13.9941 16.9707 13.8223 18.0801H20.2969ZM34.2363 19.7715H13.7637V29.1387C13.7637 30.5391 14.3281 31.8145 15.2402 32.748L15.2832 32.7891C16.2207 33.7266 17.5156 34.3105 18.9355 34.3105H29.0645C30.4863 34.3105 31.7793 33.7285 32.7148 32.793L32.7188 32.7891C33.6543 31.8535 34.2363 30.5605 34.2363 29.1387V19.7715ZM22.0234 22.7324L27.2637 26.1406C27.3477 26.1953 27.4238 26.2656 27.4844 26.3516C27.7227 26.6973 27.6348 27.1719 27.2891 27.4102L22.0703 30.4902C21.9395 30.5977 21.7715 30.6621 21.5859 30.6621C21.1641 30.6621 20.8223 30.3203 20.8223 29.8984V23.3574H20.8262C20.8262 23.207 20.8711 23.0547 20.9629 22.9219C21.2051 22.5762 21.6797 22.4922 22.0234 22.7324Z",
    fill: "#9A9AAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26796_253088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8555,
    height: 24,
    fill: "white",
    transform: "translate(12.0723 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelIcon);
export default __webpack_public_path__ + "static/media/reel_icon.b04bc4cb25599b897cd0d143efd6b9aa.svg";
export { ForwardRef as ReactComponent };